module.exports = __webpack_public_path__ + "text-warning-icon.8feed3d758dd337af2e5.svg";


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/assets/images/text-warning-icon.svg
// module id = ../../../../../src/assets/images/text-warning-icon.svg
// module chunks = styles